import { NavLink } from "react-router-dom";
import styles from "./styles/ShoppingCartNav.module.css";
import { ReactComponent as IconBasket } from "../../../assets/basket.svg";

const ShoppingCartNav = ({ count, link, disabled }) => {
    return (
        <NavLink
            draggable={"false"}
            className={`${styles.cart_container} ${
                disabled ? styles.disabled : ""
            }`}
            to={link}
            aria-label={`Shopping cart button`}
            disabled={disabled}
        >
            <div className={`${styles.count_container} flex-container`}>
                <h4>{count}</h4>
            </div>

            <IconBasket className={`${styles.icon}  icon-component`} />
        </NavLink>
    );
};

export default ShoppingCartNav;
